import { drawCamlockHole } from './camlock-hole'
import { drawCircularHole } from './circular-hole'
import { drawCountersinkHole } from './countersink-hole'
import { drawEuroCylinderHole } from './euro-cylinder-hole'
import { drawBoltHoles, drawCountersinkHoles } from './multiple-fixing-holes'
import { drawOvalCylinderHole } from './oval-cylinder.hole'
import { drawPD7Hole } from './pd7-hole'
import { drawPlate } from './plate'
import { drawPN6Hole } from './pn6-hole'
import { drawShapeHole } from './shape-hole'

export type OcWorkerGenerateRequest = {
  plate: ReturnType<(typeof ocWorkerProxyOps)['drawPlate']>
  holes: Array<ReturnType<(typeof ocWorkerProxyOps)[Exclude<keyof typeof ocWorkerProxyOps, 'drawPlate'>]>>
  mirror: boolean
}

// Type that transforms ocWorkerOps into ocWorkerProxyOps type
type OcWorkerProxyOps<T extends Record<string, (...args: any[]) => any>> = {
  [K in keyof T]: (...args: Parameters<T[K]>) => {
    op: K
    args: Parameters<T[K]>
  }
}

export const ocWorkerOps = {
  drawCamlockHole,
  drawCircularHole,
  drawCountersinkHole,
  drawEuroCylinderHole,
  drawBoltHoles,
  drawCountersinkHoles,
  drawOvalCylinderHole,
  drawPD7Hole,
  drawPlate,
  drawPN6Hole,
  drawShapeHole,
}

export const ocWorkerProxyOps: OcWorkerProxyOps<typeof ocWorkerOps> = {
  drawCamlockHole: (...args) => ({ op: 'drawCamlockHole', args }),
  drawCircularHole: (...args) => ({ op: 'drawCircularHole', args }),
  drawCountersinkHole: (...args) => ({ op: 'drawCountersinkHole', args }),
  drawEuroCylinderHole: (...args) => ({ op: 'drawEuroCylinderHole', args }),
  drawBoltHoles: (...args) => ({ op: 'drawBoltHoles', args }),
  drawCountersinkHoles: (...args) => ({ op: 'drawCountersinkHoles', args }),
  drawOvalCylinderHole: (...args) => ({ op: 'drawOvalCylinderHole', args }),
  drawPD7Hole: (...args) => ({ op: 'drawPD7Hole', args }),
  drawPlate: (...args) => ({ op: 'drawPlate', args }),
  drawPN6Hole: (...args) => ({ op: 'drawPN6Hole', args }),
  drawShapeHole: (...args) => ({ op: 'drawShapeHole', args }),
}
